import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UtilsService } from '@app/services/utils.service';

/**
 * Functional guard that blocks access in PWA standalone mode.
 * If the app is installed (standalone mode), redirects to /home.
 * Otherwise, allows access to the page (e.g., install-app).
 */
export const notStandaloneModeGuard: CanActivateFn = () => {
    const utilsService = inject(UtilsService);
    const router = inject(Router);

    if (!utilsService.isInStandaloneMode()) {
        return true;
    }

    return router.createUrlTree(['/home']);
};
